function SettingsToggleField({ id, value, disabled = false, onChange }) {
    const isOn = Boolean(value);

    return (
        <button
            id={id}
            type="button"
            role="switch"
            aria-checked={isOn}
            className={`settings-toggle ${isOn ? "is-on" : ""}`}
            disabled={disabled}
            onClick={() => onChange(!isOn)}
        >
            <span className="settings-toggle-thumb" />
        </button>
    );
}

export default SettingsToggleField;